(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["company-history"] && !Shopify.designMode) return;
  try {
    
  class HistorySlider extends HTMLElement {
    constructor() {
      super();
      this.init = this.init.bind(this);
      this.updateProgress = this.updateProgress.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.slider = this.querySelector('[data-slider]');
      if (!this.slider) return;

      // Add progress bar HTML directly inside the slider
      const progressBar = document.createElement('div');
      progressBar.className = 'slider-progress';
      progressBar.innerHTML = '<div class="slider-progress-bar"></div>';
      this.slider.appendChild(progressBar);

      this.progressBar = progressBar.querySelector('.slider-progress-bar');

      this.flkty = new Flickity(this.slider, {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        prevNextButtons: true,
        wrapAround: false,
        adaptiveHeight: false,
        cellSelector: '.history-slide',
        percentPosition: true,
        groupCells: false,
        selectedAttraction: 0.015,
        friction: 0.25,
      });

      // Update progress bar on slide change
      this.flkty.on('scroll', this.updateProgress);
    }

    updateProgress() {
      if (!this.flkty || !this.progressBar) return;

      // Calculate which slide we're on
      const slideWidth = this.flkty.size.width * 0.4; // 40% of container width
      const currentSlide = Math.floor((this.flkty.x * -1) / slideWidth);
      const progress = ((this.flkty.x * -1) % slideWidth) / slideWidth;

      // Position the progress bar under the current slide
      this.progressBar.style.transform = `translateX(${currentSlide * slideWidth}px) scaleX(${progress})`;
    }
  }

  customElements.define('history-slider', HistorySlider);

  } catch(e) { console.error(e); }
})();
})();
